/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import lodash from 'lodash';
import axios from 'axios';
import qs from 'qs';

// initial state
const state = {
  amount: null,
  invoiceNumber: null,
  note: null,
  currentSection: 'billingInfo',
  paymentSection: 'amount', // Payment Sections are a subsection within "billingInfo".
  paymentSections: ['amount', 'billing', 'cardinfo'],
  paymentStatus: null,
  errorMessage: null,
  paymentInfo: {
    cardholderName: null,
    cardNumber: null,
    expDate: null,
    cvv: null,
  },
  billingInfo: {
    street: null,
    city: null,
    state: null,
    zip: null,
  },
  transactionToken: null,
  transactionGuid: null,
  gravityObject: null,
  loaders: {
    submitting: false,
    tokenFetching: false,
  },
  loadingMessage: null,
  // ...window.INITIAL_STATE.payInvoice,
};

// getters
const getters = {
  loaders: (state) => state.loaders,
  loadingMessage: (state) => state.loadingMessage,
  errorMessage: (state) => state.errorMessage,
  amount: (state) => state.amount,
  invoiceNumber: (state) => state.invoiceNumber,
  note: (state) => state.note,
  currentSection: (state) => state.currentSection,
  paymentSection: (state) => state.paymentSection,
  paymentSections: (state) => state.paymentSections,
  paymentStatus: (state) => state.paymentStatus,
  paymentInfo: (state) => state.paymentInfo,
  billingInfo: (state) => state.billingInfo,
  member_id: (state, getters, rootState) => rootState.main.member_id,
  user: (state, getters, rootState) => rootState.auth.user,
  amountSanitized: (getters) => {
    let amount = null;
    if (getters.amount) {
      amount = parseFloat(getters.amount.replace(',', '')).toFixed(2);
    }
    return amount;
  },
  amountSanitizedReformatted: (getters) => {
    let amount = null;
    if (getters.amount) {
      let amountRaw = parseFloat(getters.amount.replace(',', '')).toFixed(2);
      let amountFmt = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amountRaw);
      amount = amountFmt.replace('$', '');
      //let sanAmount = getters.amount.replace(',', '');
      //amount = sanAmount.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }
    return amount;
  },
  paymentAmount: (state, getters) => {
    let amount = null;
    if (getters.amount) {
      amount = parseInt(parseFloat(getters.amount.replace(',', ''))*100);
    }
    return amount;
  },
  paymentPayload: (state, getters) => ({
    paymentAmount: getters.amountSanitized,
    paymentAmountCents: getters.paymentAmount,
    transactionToken: getters.transactionToken,
    transactionGuid: getters.transactionGuid,
    invoiceNumber: getters.invoiceNumber,
    note: getters.note,
    user_id: getters.user.userInfo.id,
    user_email: getters.user.userInfo.email,
    user_name: getters.user.userInfo.name,
    member_id: getters.member_id,
    paymentInfo: getters.paymentInfo,
    billingInfo: getters.billingInfo,
  }),
  paymentInfoComplete: (state) => {
    return state.paymentInfo.cardholderName !== '' && state.paymentInfo.cardholderName !== null &&
      state.paymentInfo.cardNumber !== '' && state.paymentInfo.cardNumber !== null &&
      state.paymentInfo.expDate !== '' && state.paymentInfo.expDate !== null &&
      state.paymentInfo.cvv !== '' && state.paymentInfo.cvv !== null;
  },
  formValid: (state, getters) => {
    return state.paymentAmount > 0 &&
      state.invoiceNumber !== '' && state.invoiceNumber !== null &&
      getters.paymentInfoComplete;
  },
  transactionToken: (state) => state.transactionToken,
  transactionGuid: (state) => state.transactionGuid,
  gravityApiUrl: () => {
    if (CONFIG.get('ENV') == 'PROD') {
      return 'https://api.emergepay.chargeitpro.com/virtualterminal/v1';
    } else {
      return 'https://api.emergepay-sandbox.chargeitpro.com/virtualterminal/v1';
    }
  },
  gravityAssetsUrl: () => {
    console.log('ENV: ', CONFIG.get('ENV')); // DEV or PROD

    if (CONFIG.get('ENV') == 'PROD') {
      return 'https://assets.emergepay.chargeitpro.com';
    } else {
      return 'https://assets.emergepay-sandbox.chargeitpro.com';
    }
  },
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
  setObjectProperty({ commit }, payload) {
    commit('SET_OBJECT_PROPERTY', payload);
  },

  getToken({ commit, getters, dispatch }) {
    commit('TOGGLE_LOADING', { key: 'tokenFetching', value: true });
    axios.post(`${CONFIG.get('BASE_URL')}/api/pay-invoice/getToken/`, qs.stringify(getters.paymentPayload))
      .then((response) => {
        if (response.data && response.data.transactionToken) {
          commit('SET_PROPERTY', { key: 'transactionToken', value: response.data.transactionToken });
          commit('SET_PROPERTY', { key: 'transactionGuid', value: response.data.guid });
          dispatch('initializeGravity');
        } else {
          dispatch('flash/addMessage', { text: 'Processing Error', type: 'error' }, { root: true });
          commit('SET_PROPERTY', { key: 'currentSection', value: 'outOfOrder' });
          dispatch('tokenFetchFailure', response.data);
        }
      })
      .catch((error) => {
        commit('TOGGLE_LOADING', { key: 'tokenFetching', value: false });
        console.error(error);
      });
  },

  /**
   * Tell iFuel Devs about the failure to fetch a payment token.
   */
  tokenFetchFailure({ commit, getters, dispatch }, res) {
    console.log('Failure fetching token from Gravity.');
    axios.post(`${CONFIG.get('BASE_URL')}/api/pay-invoice/getTokenFailure/`, qs.stringify({req_data: getters.paymentPayload, req_response: res}))
      .catch((error) => {
        console.error(error);
      });
  },

  initializeGravity({ commit, getters, dispatch }) {
    // Initialize the hosted fields
    window.gravityObject = emergepayFormFields.init({
      // (required) Used to set up each field
      transactionToken: getters.transactionToken,
      
      // (required) The type of transaction to run
      transactionType: "CreditSale",

      // (optional) Configure which fields to use and the id's of the elements to append each field to
      fieldSetUp: {
          // These fields are valid for credit card transactions
          cardNumber: {
              appendToSelector: "cardNumberContainer",
              useField: true,
              // optional, automatically sets the height of the iframe to the height of the
              // contents within the iframe. Useful when using the styles object
              autoIframeHeight: true,
              styles: { "border": "1px solid #ccc" }
          },
          cardExpirationDate: {
              appendToSelector: "expirationDateContainer",
              useField: true,
              // optional, automatically sets the height of the iframe to the height of the
              // contents within the iframe. Useful when using the styles object
              autoIframeHeight: true,
              styles: { "border": "1px solid #ccc" }
          },
          cardSecurityCode: {
              appendToSelector: "securityCodeContainer",
              useField: true,
              // optional, automatically sets the height of the iframe to the height of the
              // contents within the iframe. Useful when using the styles object
              autoIframeHeight: true,
              styles: { "border": "1px solid #ccc" }
          },
          // These fields are valid for all transaction types
          totalAmount: {
              useField: false,
          },
          externalTranId: {
              useField: false
          }
      }, // end fieldSetup
      
      // (optional) If there is a validation error for a field, the styles set in this object will be applied to the field
      fieldErrorStyles: {
          "border": "1px dashed red"
      },
      // (optional) This callback function will be called when there is a validation error for a field.
      onFieldError: function (data) {
          //console.log(data);
          commit('SET_PROPERTY', { key: 'errorMessage', value: data.result });
          commit('TOGGLE_LOADING', { key: 'submitting', value: false });
          //dispatch('payInvoice/initializeGravity','',{root: true});
      },
      // (optional) This callback function will be called when a field validation error has been cleared.
      onFieldErrorCleared: function (data) {
          //console.log(data);
          commit('SET_PROPERTY', { key: 'errorMessage', value: null });
      },
      // (optional) This callback function will be called when all of the requested fields have loaded
      // and are ready to accept user input. This can be useful for things like toggling the status
      // of loading indicators or ignoring clicks on a button until all of the fields are fully loaded
      onFieldsLoaded: function() {
          //console.log('All fields loaded');
          commit('TOGGLE_LOADING', { key: 'tokenFetching', value: false });
      },
      // (optional) Callback function that gets called after a successful transaction
      // onTransactionSuccess: function (approvalData) {
      //     dispatch('payInvoice/handleTransactionSuccess', approvalData, { root: true });
      // },
      // (optional) Callback function that gets called after a failure occurs during the transaction (such as a declined card)
      // onTransactionFailure: function (failureData) {
      //     dispatch('payInvoice/handleTransactionFailure', failureData, { root: true });
      // },
      // (optional) Callback function that gets called after the user enters the first 6 digits of their card number.
      // This can be useful for showing a card brand icon to the user, or for determining if the card entered
      // is a credit card or a debit card.
      // onBinChange: function(binData) {
      //   // console.log('bin', binData.bin);
      //   // console.log('card type', binData.cardType);
      // }
    });

  },

  submitPayment({ commit, getters, dispatch }) {
    //console.log('Form submitted');
    commit('TOGGLE_LOADING', { key: 'submitting', value: true });

    // Log payment attempt in iFuel
    axios.post(`${CONFIG.get('BASE_URL')}/api/pay-invoice/logPayment/`, qs.stringify(getters.paymentPayload))
      .then((response) => {
        // Start payment through Gravity 
        window.gravityObject.process();

        // Start a timeout that lets the user know we are still working on their request and not frozen
        setTimeout(function() {
          if (!getters.paymentStatus && !getters.errorMessage) {
            //console.log("Still working on it!");
            commit('SET_PROPERTY', { key: 'loadingMessage', value: "Sorry for the wait, we're still attempting to confirm the payment went through." });
          }
        }, 30000);

        // After a brief delay, tell iFuel to start polling for the result of the transaction.
        setTimeout(function() {
          if (!getters.errorMessage) {
            //console.log("Polling for status started!");
            commit('SET_PROPERTY', { key: 'loadingMessage', value: "Submitting to payment processor..." });
            dispatch('payInvoice/getStatus', null, { root: true });
          }
        }, 1000);
        //dispatch('getStatus');
      })
      .catch((error) => {
        console.error(error);
      });

    // Note: loading indicator will be turned off when the success or failure callback is called by Gravity. 
    // See initializeGravity() action.
  },

  getStatus({ commit, getters, dispatch }) {
    // Send Request to iFuel to get the status of a transaction
    axios.get(`${CONFIG.get('BASE_URL')}/api/pay-invoice/getStatus/${getters.transactionGuid}/`)
      .then((response) => {
        console.log('statusData', response.data);
        if (response.data && response.data.transactionResponse) {
          let payment = response.data.transactionResponse;

          // Store the returned result status
          commit('SET_PROPERTY', { key: 'paymentStatus', value: payment.resultMessage });
          commit('SET_PROPERTY', { key: 'loadingMessage', value: null });

          // If payment successful
          if (payment.resultMessage == 'Approved') {
            dispatch('payInvoice/handleTransactionSuccess', payment, { root: true });
          } 
          
          // If no response from GravityPay
          else if (payment.resultMessage == 'Unknown') {
            commit('TOGGLE_LOADING', { key: 'submitting', value: false });
            commit('SET_PROPERTY', { key: 'currentSection', value: 'unknownMessage' });
          } 

          // Assumed failure (don't actually know the result message when failed transaction)
          else {
            dispatch('payInvoice/handleTransactionFailure', payment, { root: true });
          }
        } else {
          console.log("Attempt to fetch payment status seems to have timed out or had another unknown error.");
          commit('TOGGLE_LOADING', { key: 'submitting', value: false });
          commit('SET_PROPERTY', { key: 'currentSection', value: 'unknownMessage' });
        }
      })
      .catch((error) => {
        console.error(error);
      });
      
  },

  handleTransactionSuccess({ commit, getters, dispatch }, approvalData) {
    console.log('approvalData', approvalData);
    
    commit('TOGGLE_LOADING', { key: 'submitting', value: false });
    dispatch('flash/addMessage', { text: 'Payment Received!' }, { root: true });
    commit('SET_PROPERTY', { key: 'currentSection', value: 'successMessage' });

    // Send Request to iFuel to log the success of this transaction
    axios.post(`${CONFIG.get('BASE_URL')}/api/pay-invoice/paymentSuccess/`, qs.stringify(approvalData))
      .catch((error) => {
        console.error(error);
      });
  },

  handleTransactionFailure({ commit, getters, dispatch }, failureData) {
    console.log('failureData', failureData);
    
    commit('TOGGLE_LOADING', { key: 'submitting', value: false });
    dispatch('flash/addMessage', { text: 'Transaction Error - Please try again', type: 'error' }, { root: true });
    commit('SET_PROPERTY', { key: 'errorMessage', value: failureData.resultMessage });
    commit('SET_PROPERTY', { key: 'paymentSection', value: 'billing' });
    

    // Send Request to iFuel to log the failure of this transaction
    axios.post(`${CONFIG.get('BASE_URL')}/api/pay-invoice/paymentFailure/`, qs.stringify(failureData))
      .catch((error) => {
        console.error(error);
      });
  },

  resetForm({ commit }) {
    window.location = CONFIG.get('BASE_URL')+'/pay-invoice';
    // commit('SET_PROPERTY', { key: 'amount', value: null });
    // commit('SET_PROPERTY', { key: 'invoiceNumber', value: null });
    // commit('SET_PROPERTY', { key: 'errorMessage', value: null });
    // commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'cardholderName', value: null });
    // commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'cardNumber', value: null });
    // commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'expDate', value: null });
    // commit('SET_OBJECT_PROPERTY', { object: 'paymentInfo', key: 'cvv', value: null });
    // commit('SET_PROPERTY', { key: 'currentSection', value: 'billingInfo' });
    // commit('SET_PROPERTY', { key: 'paymentSection', value: 'amount' });
    // commit('SET_PROPERTY', { key: 'transactionToken', value: null });
    // commit('SET_PROPERTY', { key: 'transactionGuid', value: null });
  },
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  SET_OBJECT_PROPERTY(state, payload) {
    state[payload.object][payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  RESET_PRODUCT_FORM(state) {
    state.amount = null;
    state.invoiceNumber = null;
    state.currentSection = 'amount';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
